<template>
  <div id="Profile" v-if="user" class="wrap">
    <div class="maxContainer">
      <v-container>
        <v-card flat class="mt-3">

          <v-flex xs12>
              <v-text-field
                v-model="user.name"
                label="Name"
                readonly
              ></v-text-field>
          </v-flex>

          <v-flex xs12>
              <v-text-field
                v-model="user.email"
                label="Email"
                readonly
              ></v-text-field>
          </v-flex>
        </v-card>

        <v-card v-if="user.user_profile" outlined class="mt-3">
          <v-card-title @click="editPrepaStatus()" class="pa-0">
            <v-layout class="grey lighten-3" align-center>
              <v-layout  class="grey lighten-3" py-2>
                <p class="subtitle-1 text--primary ml-2 mb-0">My Pre-PA Status</p>
              </v-layout>
              <v-spacer></v-spacer>
              <v-icon class="mr-2">mdi-pencil</v-icon>
            </v-layout>
          </v-card-title>

          <v-card-text class="pl-2">
            <v-text-field
              color="black"
              v-model="user.user_profile.applicant_application_cycle"
              label="Cycle im applying"
              readonly
              class="mt-5 pt-3  mx-3"
              hide-details
              >
            </v-text-field>

            <v-layout v-if="user.user_profile.applicant_status === 'firstapplicant'" row  mt-0 align-center mb-2 >
              <v-checkbox readonly v-model="user.user_profile.applicant_status" class=" ml-5 shrink" color="blue"  label="First Time Applicant" hide-details ></v-checkbox>
            </v-layout>

            <v-layout v-if="user.user_profile.applicant_status === 'reapplicant'" row  mt-0 align-center mb-2 >
              <v-checkbox readonly v-model="user.user_profile.applicant_status" class="mt-3 ml-5 shrink" color="blue"  label="Re-Applicant" hide-details ></v-checkbox>
            </v-layout>

            <v-layout v-if="user.user_profile.applicant_international_status === 'true'" row  mt-0 align-center mb-2 >
              <v-checkbox readonly v-model="user.user_profile.applicant_international_status" class="mt-3 ml-5 shrink" color="blue"  label="International Student" hide-details ></v-checkbox>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>

      <v-container v-if="validSubscription && user.user_profile === false">
        <v-card flat>
          <span>Please complete your Pre-PA profile </span>
          <v-btn to="/userquestions">Complete Profile</v-btn>
        </v-card>
      </v-container>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      applicant_status: null,
      applicant_application_cycle: '',
      applicant_international_status: '',
      showSavedButton: false
    }
  },
  methods: {
    editPrepaStatus() {
      this.$router.push('/userquestions')
    }

  },
  computed: {
    ...mapGetters(['validSubscription']),
    user() {
      return this.$store.getters.user;
    },



  },
  watch : {
    showSavedButton (value) {
      if(value === null) {
         console.log(value)
      }



    }
  }
}
</script>

<style scoped>
.maxContainer {
  max-width: 1280px;
  margin: 0 auto;
}

.wrap {
  margin-top: 8vh !important;
}

</style>



// WEBPACK FOOTER //
// src/components/User/Profile.vue